module.exports = __webpack_public_path__ + "img/facebook.eb5381d5.svg";